module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Beer-097b748eae35935b85ea1871e78af4d6aedeb538175ea2fdf5657035b6d42c84.svg";